export default {
  GET_AVAILABLE_DOMAINS_REQUEST: '@@available-domains/GET_AVAILABLE_DOMAINS_REQUEST',
  GET_AVAILABLE_DOMAINS_SUCCESS: '@@available-domains/GET_AVAILABLE_DOMAINS_SUCCESS',
  GET_AVAILABLE_DOMAINS_ERROR: '@@available-domains/GET_AVAILABLE_DOMAINS_ERROR',
};
